<template>
  <div
    class="flex flex-wrap items-center justify-center gap-2 px-4 text-center"
    :class="[compact ? '!px-0' : (hasImage ? 'py-2' : 'py-8'), dragging ? 'bg-[#ecd79f]/30' : '']"
    @dragover.prevent.stop="dragging = true"
    @dragleave.prevent="dragging = false"
    @drop.prevent.stop="onDrop"
  >
    <input ref="input" type="file" accept="image/jpeg,image/png,image/webp" :multiple="multiple" class="sr-only" tabindex="-1" aria-label="Choose an image" @change="onPick">
    <button type="button" class="min-h-9 rounded-lg bg-[#1c4848]/5 px-3 text-xs font-bold text-[#1c4848] hover:bg-[#1c4848]/10 disabled:opacity-50" :disabled="busy" @click="input.click()">
      {{ busy ? 'Uploading…' : (hasImage ? 'Replace image' : (multiple ? 'Add images' : 'Choose an image')) }}
    </button>
    <span v-if="!hasImage && !busy && !compact" class="text-xs text-[#1c4848]/45">or drop {{ multiple ? 'them' : 'it' }} here</span>
    <p v-if="error" role="alert" class="w-full text-xs text-red-700">{{ error }}</p>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  context: { type: Object, required: true },
  hasImage: { type: Boolean, default: false },
  multiple: { type: Boolean, default: false },
  compact: { type: Boolean, default: false },
});
const emit = defineEmits(['picked']);

const input = ref(null);
const busy = ref(false);
const error = ref('');
const dragging = ref(false);

async function upload(files) {
  if (!files.length) return;
  busy.value = true;
  error.value = '';
  try {
    for (const file of files) emit('picked', await props.context.uploadImage(file));
  } catch (e) {
    error.value = e?.response?.data?.errors?.file?.[0] ?? 'The image could not be uploaded.';
  } finally {
    busy.value = false;
  }
}

function onPick(event) {
  const files = [...event.target.files];
  event.target.value = '';
  upload(files);
}

function onDrop(event) {
  dragging.value = false;
  upload([...event.dataTransfer.files].filter((f) => f.type.startsWith('image/')).slice(0, props.multiple ? 20 : 1));
}
</script>
